import { Box } from '@mui/system';
import { GridRenderCellParams } from '@mui/x-data-grid';
import React from 'react';
import { UserStatus } from 'types/common';
import UserChip from '../Chip/UserChip';

const UserStatusCell: React.FC<GridRenderCellParams<string>> = ({ value }) => (
	<Box display="flex" flexGrow={1}>
		<UserChip status={value as UserStatus} />
	</Box>
);

export default UserStatusCell;
